module.exports = __webpack_public_path__ + "img/logo_tunno.c2eef44f.png";